import { render } from "./NodeListsWildcard.vue?vue&type=template&id=4bc28bf5&scoped=true"
import script from "./NodeListsWildcard.vue?vue&type=script&lang=js"
export * from "./NodeListsWildcard.vue?vue&type=script&lang=js"

import "./NodeListsWildcard.vue?vue&type=style&index=0&id=4bc28bf5&scoped=true&lang=sass"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc28bf5"]])

export default __exports__